/* eslint-disable import/first */
import React, { useContext } from 'react';
import { navigate } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Grid, Button } from '@material-ui/core';
import { useIntl } from 'react-intl';
import ClassNames from 'classnames';
import { AiOutlineCheck } from '@react-icons/all-files/ai/AiOutlineCheck';
const {
  fetchConfig,
  selectCountryValidations,
  getHomeJsonComponents,
  getClusterId,
} = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { fetchMenu } = Slices.menuSlice;
const { fetchHome } = Slices.homeSlice;
const { clearCategory, setRefetch } = Slices.categorySlice;
import { capitalizeFirstLetter, getCurrentBrand } from 'spwa-ui-library/esm/utils/helper';
import { Context } from '../../components/Multi-lang/Wrapper';

import css from './index.module.scss';
import { langSwitchGA } from 'spwa-ui-library/esm/utils/helperGA';

const LanguageButton = ({ onClick, className, sideMenu }) => {
  const context = useContext(Context);
  const clusterId = useSelector(getClusterId);
  const intl = useIntl();
  const dispatch = useDispatch();
  const country = useSelector(selectCurrentCountry);
  // const menu = useSelector(selectFirstMenu);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  // eslint:fix countryValidations is defined but never used
  const blobURL = useSelector(getHomeJsonComponents);

  const lang = intl.locale.split('-')[0].toLowerCase();
  const newLang = lang === 'en' ? 'ar' : 'en';
  const label = lang === 'en' ? 'عربي' : 'English';
  const newUrl = window.location.pathname
    .split('/')
    .map((item) => (item === lang ? newLang : item))
    .join('/');
  const handleClick = (e) => {
    e.preventDefault();
    navigate(newUrl, { replace: true });
    context.selectLanguage(newLang);
    dispatch(fetchConfig());
    const menuID = countryValidations?.defaultMenuId;
    const defaultMenu = countryValidations?.defaultMenuTempId;
    dispatch(clearCategory());
    dispatch(
      fetchMenu({
        blob: blobURL,
        country: country.toUpperCase(),
        brand: getCurrentBrand(),
        menu: defaultMenu,
        defMenu: menuID,
        cluster: clusterId,
        lang: capitalizeFirstLetter(newLang),
      })
    );

    dispatch(
      fetchHome({
        cluster: clusterId,
        country: country.toLowerCase(),
        lang: capitalizeFirstLetter(newLang),
      })
    );

    dispatch(
      setRefetch({
        refetch: true,
      })
    );

    langSwitchGA(lang, newLang);
    onClick && onClick.apply(e.target, [e, newLang]);
  };

  return (
    <Grid className={ClassNames(css.root, className, (css.sideButton: sideMenu))}>
      {sideMenu ? (
        <>
          <Button
            href={newUrl}
            className={lang === 'en' ? css.langButtonActive : css.langButtonSideMenu}
            onClick={handleClick}
            startIcon={lang === 'en' && <AiOutlineCheck size="1em" color="#fff" />}
          >
            {'English'}
          </Button>
          <Button
            href={newUrl}
            onClick={handleClick}
            startIcon={lang === 'ar' && <AiOutlineCheck size="1em" color="#fff" />}
            className={lang === 'ar' ? css.langButtonActive : css.langButtonSideMenu}
          >
            {'عربي'}
          </Button>
        </>
      ) : (
        <Button href={newUrl} variant="outlined" onClick={handleClick} className={css.langButton}>
          {label}
        </Button>
      )}
    </Grid>
  );
};

export default LanguageButton;
